import { Badge } from "reactstrap";
import i18n from "../../../i18n";

export function printUserStatus(status) {
  switch(status) {
    case 'pending':
      return <Badge color="warning">{i18n.t('common.pending')}</Badge>;
    case 'active':
      return <Badge color="success">{i18n.t('common.active')}</Badge>;
    case 'suspended':
      return <Badge color="danger">{i18n.t('common.suspended')}</Badge>;
    default:
      return <Badge color="secondary">{i18n.t('common.unknown')}</Badge>;
  }
}

export function printPaymentStatus(status) {
  switch(status) {
    case 'paid':
      return <Badge color="success">{i18n.t('common.paid')}</Badge>;
    case 'failed':
      return <Badge color="danger">{i18n.t('common.failed')}</Badge>;
    case 'pending':
      return <Badge color="warning">{i18n.t('common.pending')}</Badge>;
    default:
      return <Badge color="secondary">{i18n.t('common.unknown')}</Badge>;
  }
}
